import React from "react";

const dommyText = () => {
  // return "pk_test_36ec67817723768674dfa3360c450b9ba00de9fb";
  return "pk_live_519f4cc72a75befcde056d48b9b2ace0941ed4d1"
};

export default dommyText;
